<template>
	<div id="competitive-position">
		<headerbar></headerbar>
		<div class="bluebanner" v-title v-bind:data-title="city+'投资环境评估分析报告'">
			<div class="centerpage1">
				<h2 class="title">竞争地位</h2>
				<p> </p>
			</div>
		</div>
		<ul class="fixedfloor-indata" v-show="showfloor">
			<li v-for="(item,index) in steplist" :class="curstepp == index ? 'current floorstep':'floorstep'">{{item}}</li>  
		</ul>
		<div class="competitive-cityscreen">
			<div class="centerpage1">
				<h3 class="title">请选择您要查询的区域</h3>
				<div class="selectbox-indata">
					<!-- <div class="slectbox">
					<span class="optionselected">省份/直辖市</span>
					<ul>
						<li></li>
					</ul>
				</div>
				<div class="slectbox">
					<span class="optionselected">城市</span>
					<ul>
						<li></li>
					</ul>
				</div>
				<div class="slectbox">
					<span class="optionselected">区县</span>
					<ul>
						<li></li>
					</ul>
				</div>
				<div class="slectbox">
					<span class="optionselected">乡镇</span>
					<ul>
						<li></li>
					</ul>
				</div> -->
					<select name="" id="" class="slectbox">
						<option value="">省份/直辖市</option>
					</select>
					<select name="" id="" class="slectbox">
						<option value="">城市</option>
					</select>
					<select name="" id="" class="slectbox">
						<option value="">区县</option>
					</select>
					<select name="" id="" class="slectbox">
						<option value="">乡镇</option>
					</select>
					<div class="citysearch fl"><img src="/src/assets/searchicon1.png" alt=""></div>
				</div>
			</div>
		</div>
		<div class="cityinvestment-data centerpage1" id="investmentdata-article">
			<h2 class="title">{{articledata.title}}</h2>
			<div class="in_environment">
				<h3 class="ph-heading">{{articledata.investmentenvironment.title}}</h3>
				<div v-html="articledata.investmentenvironment.htmls" class="ph_htmls"></div>
				<div class="echart_radar" id="echart_radar1"></div>
				<table class="indata-tabel" width="1344" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th>指标</th>
						<th>得分</th>
						<th>全国排名</th>
						<th>排名解读</th>
					</tr>
					<tr v-for="(item,index) in articledata.investmentenvironment.data">
						<td>{{item.name}}</td>
						<td>{{item.score}}</td>
						<td>{{item.ranking}}</td>
						<td>{{item.remark}}</td>
					</tr>
				</table>
			</div>
			<div class="in_environment">
				<h3 class="ph-heading">{{articledata.economicstrength.title}}</h3>
				<div v-html="articledata.economicstrength.htmls" class="ph_htmls"></div>
				<div class="echart_radar" id="echart_radar2"></div>
				<table class="indata-tabel" width="1344" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th>指标</th>
						<th>得分</th>
						<th>全国排名</th>
						<th>排名解读</th>
					</tr>
					<tr v-for="(item,index) in articledata.economicstrength.data">
						<td>{{item.name}}</td>
						<td>{{item.score}}</td>
						<td>{{item.ranking}}</td>
						<td>{{item.remark}}</td>
					</tr>
				</table>
			</div>
			<div class="in_environment">
				<h3 class="ph-heading">{{articledata.developmentQuality.title}}</h3>
				<div v-html="articledata.developmentQuality.htmls" class="ph_htmls"></div>
				<div class="echart_radar" id="echart_radar3"></div>
				<table class="indata-tabel" width="1344" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th>指标</th>
						<th>得分</th>
						<th>全国排名</th>
						<th>排名解读</th>
					</tr>
					<tr v-for="(item,index) in articledata.developmentQuality.data">
						<td>{{item.name}}</td>
						<td>{{item.score}}</td>
						<td>{{item.ranking}}</td>
						<td>{{item.remark}}</td>
					</tr>
				</table>
			</div>
			<div class="in_environment">
				<h3 class="ph-heading">{{articledata.economicOpenness.title}}</h3>
				<div v-html="articledata.economicOpenness.htmls" class="ph_htmls"></div>
				<!-- <div class="echart_radar" id="echart_radar4"></div> -->
				<table class="indata-tabel" width="1344" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th>指标</th>
						<th>得分</th>
						<th>全国排名</th>
						<th>排名解读</th>
					</tr>
					<tr v-for="(item,index) in articledata.economicOpenness.data">
						<td>{{item.name}}</td>
						<td>{{item.score}}</td>
						<td>{{item.ranking}}</td>
						<td>{{item.remark}}</td>
					</tr>
				</table>
			</div>
			<div class="in_environment">
				<h3 class="ph-heading">{{articledata.marketSize.title}}</h3>
				<div v-html="articledata.marketSize.htmls" class="ph_htmls"></div>
				<div class="echart_radar" id="echart_radar5"></div>
				<table class="indata-tabel" width="1344" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th>指标</th>
						<th>得分</th>
						<th>全国排名</th>
						<th>排名解读</th>
					</tr>
					<tr v-for="(item,index) in articledata.marketSize.data">
						<td>{{item.name}}</td>
						<td>{{item.score}}</td>
						<td>{{item.ranking}}</td>
						<td>{{item.remark}}</td>
					</tr>
				</table>
			</div>
			<div class="in_environment">
				<h3 class="ph-heading">{{articledata.logisticsVolume.title}}</h3>
				<div v-html="articledata.logisticsVolume.htmls" class="ph_htmls"></div>
				<!-- <div class="echart_radar" id="echart_radar6"></div> -->
				<table class="indata-tabel" width="1344" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th>指标</th>
						<th>得分</th>
						<th>全国排名</th>
						<th>排名解读</th>
					</tr>
					<tr v-for="(item,index) in articledata.logisticsVolume.data">
						<td>{{item.name}}</td>
						<td>{{item.score}}</td>
						<td>{{item.ranking}}</td>
						<td>{{item.remark}}</td>
					</tr>
				</table>
			</div>
			laborAdequacy 
			<div class="in_environment">
				<h3 class="ph-heading">{{articledata.laborAdequacy.title}}</h3>
				<div v-html="articledata.laborAdequacy.htmls" class="ph_htmls"></div>
				<div class="echart_radar" id="echart_radar7"></div>
				<table class="indata-tabel" width="1344" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th>指标</th>
						<th>得分</th>
						<th>全国排名</th>
						<th>排名解读</th>
					</tr>
					<tr v-for="(item,index) in articledata.laborAdequacy.data">
						<td>{{item.name}}</td>
						<td>{{item.score}}</td>
						<td>{{item.ranking}}</td>
						<td>{{item.remark}}</td>
					</tr>
				</table>
			</div> 
			<div class="in_environment">
				<h3 class="ph-heading">{{articledata.sctalentResources.title}}</h3>
				<div v-html="articledata.sctalentResources.htmls" class="ph_htmls"></div>
				<!-- <div class="echart_radar" id="echart_radar8"></div> -->
				<table class="indata-tabel" width="1344" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th>指标</th>
						<th>得分</th>
						<th>全国排名</th>
						<th>排名解读</th>
					</tr>
					<tr v-for="(item,index) in articledata.sctalentResources.data">
						<td>{{item.name}}</td>
						<td>{{item.score}}</td>
						<td>{{item.ranking}}</td>
						<td>{{item.remark}}</td>
					</tr>
				</table>
			</div> 
			<div class="in_environment">
				<h3 class="ph-heading">{{articledata.livingEnvironment.title}}</h3>
				<div v-html="articledata.livingEnvironment.htmls" class="ph_htmls"></div>
				<!-- <div class="echart_radar" id="echart_radar9"></div> -->
				<table class="indata-tabel" width="1344" border="0" cellspacing="0" cellpadding="0">
					<tr>
						<th colspan="2">指标</th>
						<th>得分</th>
						<th>全国排名</th>
						<th>排名解读</th>
					</tr>
					<tr v-for="(item,index) in articledata.livingEnvironment.data[0].datas"> 
							<td v-if="index == 0" v-bind:rowspan="index == 0 ?articledata.livingEnvironment.data[0].datas.length:'1'">{{articledata.livingEnvironment.data[0].name}}</td>
							<td>{{item.name}}</td>
							<td>{{item.score}}</td>
							<td>{{item.ranking}}</td>
							<td>{{item.remark}}</td> 
					</tr>
						<tr v-for="(item,index) in articledata.livingEnvironment.data[1].datas">
								<td v-if="index == 0" v-bind:rowspan="index == 0 ?articledata.livingEnvironment.data[1].datas.length:'1'">{{articledata.livingEnvironment.data[1].name}}</td>
								<td>{{item.name}}</td>
								<td>{{item.score}}</td>
								<td>{{item.ranking}}</td>
								<td>{{item.remark}}</td> 
						</tr> 
						<tr v-for="(item,index) in articledata.livingEnvironment.data[2].datas">
								<td v-if="index == 0" v-bind:rowspan="index == 0 ?articledata.livingEnvironment.data[2].datas.length:'1'">{{articledata.livingEnvironment.data[2].name}}</td>
								<td>{{item.name}}</td>
								<td>{{item.score}}</td>
								<td>{{item.ranking}}</td>
								<td>{{item.remark}}</td> 
						</tr> 
						<tr v-for="(item,index) in articledata.livingEnvironment.data[3].datas">
								<td v-if="index == 0" v-bind:rowspan="index == 0 ?articledata.livingEnvironment.data[3].datas.length:'1'">{{articledata.livingEnvironment.data[3].name}}</td>
								<td>{{item.name}}</td>
								<td>{{item.score}}</td>
								<td>{{item.ranking}}</td>
								<td>{{item.remark}}</td> 
						</tr> 
				</table>
			</div>
		</div>
		<footerbar></footerbar>
	</div>
</template>

<script>
	var BetaConfig = {
    startYear: 2010,
    colorIndex: 0,
    colors: ["#2C68B3", "#558ED5", "#8EB4E3", "#C6D9F1", "#72BFC5", "#C00000", "#FF8618", "#7F7F7F"],
    color: {
        red: "#C00000",
        blue: "#2e6da4"
    },
    columnFlag: {
        Nation: 1,
        Province: 2,
        City: 3,
        County: 4,
        Town: 5
    },
    ZXS: {
        11: "北京市",
        12: "天津市",
        31: "上海市",
        50: "重庆市"
    },
    getColor: function(o) {
        return BetaConfig.colors[o - 1]
    },
    itemStyle: function(o) {
        return {
            normal: {
                color: BetaConfig.colors[o - 1]
            }
        }
    },
    resetIndex: function() {
        this.colorIndex = 0
    }
};
var floortoparry=[];
	export default {
		name: 'competitive-position',
		data() {
			return {
				msg: "招商数据",
				city: '北京',
				cityid: 36451,
				showfloor: false,
				articledata: {},
				steplist:['投资环境八大要素','整体经济实力','经济发展质量','经济开放度','消费市场规模','物流运量规模','劳动力充裕度','科技人才资源','生活居住环境',],
				curstepp:0,
			}
		},
		created() {
			var articledata = {
				title: "北京市投资环境评估分析报告",
				investmentenvironment: {
					title: "北京市投资环境八大要素综合评分",
					htmls: '<ul class="alist dotlist"> <li>北京市投资环境总体评分为<b>95.5</b>分，在全国地级以上城市中综合排第<b>1</b>名，超越全国<b>100%</b>的城市。</li> <li>在构成投资环境总体评估的八大项指标中，北京市相对得分较高的是<b>消费市场规模、生活居住环境和整体经济实力</b>三个指标；相对得分较低的是<b>物流运量规模、劳动力充裕度和经济开放度</b>三个指标。</li> <li style="display:none">北京市投资环境评分在<a href="" target="_blank"></a>地级以上城市中，排名第<b>1</b>位，处于<b>第一梯队</b>。</li> <li style="display:none">从发展进程上来看，北京市。</li> <li style="display:none">北京市所辖的县市（不含市辖区）中，投资环境总体评分排前三位的地区是<b>。</b></li> </ul>',
					data: [{
							name: "整体经济实力",
							score: 98.5,
							ranking: 2,
							remark: "超过全国99.7%的城市，整体经济实力十分强"
						},
						{
							name: "经济发展质量",
							score: 97.9,
							ranking: 2,
							remark: "超过全国99.7%的城市，经济发展质量特别高"
						},
						{
							name: "经济开放度",
							score: 91.0,
							ranking: 7,
							remark: "超过全国98.2%的城市，经济开放度很高"
						},
						{
							name: "消费市场规模",
							score: 100,
							ranking: 1,
							remark: "超过全国100%的城市，消费市场规模特别大"
						},
						{
							name: "物流运量规模",
							score: 89.9,
							ranking: 3,
							remark: "超过全国99.4%的城市，物流运量规模很大"
						},
						{
							name: "劳动力充裕度",
							score: 90.3,
							ranking: 4,
							remark: "超过全国99.1%的城市，劳动力充裕度较充裕"
						},
						{
							name: "科技人才资源",
							score: 94.9,
							ranking: 4,
							remark: "超过全国99.1%的城市，科技人才资源较丰富"
						},
						{
							name: "生活居住环境",
							score: 98.9,
							ranking: 3,
							remark: "超过全国99.4%的城市，生活居住环境很优越"
						}
					]
				},
				economicstrength: {
					title: "北京市整体经济实力综合分析评估",
					htmls: '<ul class="alist dotlist"> <li>北京市整体经济实力综合评分为<b>98.5</b>分，在全国地级以上城市中综合排名第<b>2</b>名，超越全国其他<b>99.7%</b>城市。</li> <li>在构成整体经济实力的<b>7</b>个指标中，北京市相对得分最高的指标是<b>社会消费品零售总额、GDP和金融机构贷款余额</b>三个指标。</li> <li style="display:none">北京市整体经济实力在地级以上城市中，排名第<b>1</b>位。</li> </ul>',
					data: [{
							name: "GDP",
							score: 98.8,
							ranking: 2,
							remark: "超过全国99.7%的城市"
						},
						{
							name: "财政收入",
							score: 98.4,
							ranking: 2,
							remark: "超过全国99.7%的城市"
						},
						{
							name: "固定资产投资额",
							score: 96,
							ranking: 4,
							remark: "超过全国99.1%的城市"
						},
						{
							name: "当年实际使用外资金额",
							score: 95.5,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						},
						{
							name: "进出口总额",
							score: 95.5,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						},
						{
							name: "社会消费品零售总额",
							score: 100,
							ranking: 1,
							remark: "超过全国100%的城市"
						},
						{
							name: "金融机构贷款余额",
							score: 98.6,
							ranking: 2,
							remark: "超过全国99.7%的城市"
						} 
					]
				},
				developmentQuality : {
					title: "北京市经济发展质量综合分析评估",
					htmls: '<ul class="alist dotlist"> <li>北京市经济发展质量综合评分为<b>97.9</b>分，在全国地级以上城市中综合排名第<b>2</b>名，超越全国其他<b>99.7%</b>城市。</li> <li>在构成经济发展质量的<b>6</b>个指标中，北京市相对得分最高的指标是<b>第三产业占GDP比重、科学研发强度和政府财政收入比</b>三个指标。</li> <li style="display:none">北京市经济发展质量在地级以上城市中，排名第<b>1</b>位。</li> </ul>',
					data: [{
							name: "GDP增速",
							score: 39.4,
							ranking: 259,
							remark: "超过全国23.2%的城市"
						},
						{
							name: "人均GDP",
							score: 75.2,
							ranking: 21,
							remark: "超过全国94%的城市"
						},
						{
							name: "政府财政收入比",
							score: 96.2,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						},
						{
							name: "第三产业占GDP比重",
							score: 100,
							ranking: 1,
							remark: "超过全国100%的城市"
						},
						{
							name: "每万人拥有规模以上工业企业数量",
							score: 44.3,
							ranking: 193,
							remark: "超过全国42.9%的城市"
						},
						{
							name: "科学研发强度",
							score: 97.7,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						} 
					]
				}, 
				economicOpenness : {
					title: "北京市经济开放度综合分析评估",
					htmls: '<ul class="alist dotlist"> <li>北京市经济开放度综合评分为<b>91</b>分，在全国地级以上城市中综合排名第<b>7</b>名，超越全国其他<b>98.2%</b>城市。</li> <li>在构成经济开放度的<b>6</b>个指标中，北京市相对得分最高的指标是<b>进出口总值、当年实际使用外资金额和外贸依存度</b>三个指标。</li> <li style="display:none">北京市经济开放度在地级以上城市中，排名第<b>1</b>位。</li> </ul>',
					data: [{
							name: "进出口总值",
							score: 95.5,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						},
						{
							name: "外贸依存度",
							score: 91.9,
							ranking: 13,
							remark: "超过全国96.4%的城市"
						},
						{
							name: "外商及港澳台工业企业数比例",
							score: 75.6,
							ranking: 28,
							remark: "超过全国92%的城市"
						},
						{
							name: "外商及港澳台工业总产值比例",
							score: 75,
							ranking: 13,
							remark: "超过全国96.4%的城市"
						},
						{
							name: "外商直接投资合同项目数",
							score: 88.2,
							ranking: 8,
							remark: "超过全国97.9%的城市"
						},
						{
							name: "当年实际使用外资金额",
							score: 95.5,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						} 
					]
				}, 
				marketSize : {
					title: "北京市消费市场规模综合分析评估",
					htmls: '<ul class="alist dotlist"> <li>北京市消费市场规模综合评分为<b>100</b>分，在全国地级以上城市中综合排名第<b>1</b>名，超越全国其他<b>100%</b>城市。</li> <li>在构成消费市场规模的<b>5</b>个指标中，北京市相对得分最高的指标是<b>社会消费品零售总额、居民人民币储蓄存款余额和常住人口数量</b>三个指标。</li> <li style="display:none">北京市消费市场规模在地级以上城市中，排名第<b>1</b>位。</li> </ul>',
					data: [{
							name: "社会消费品零售总额",
							score: 100,
							ranking: 1,
							remark: "超过全国100%的城市"
						},
						{
							name: "常住人口数量",
							score: 98.3,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						},
						{
							name: "居民人民币储蓄存款余额",
							score: 100,
							ranking: 1,
							remark: "超过全国100%的城市"
						},
						{
							name: "职工平均工资",
							score: 98,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						},
						{
							name: "人均可支配收入",
							score: 98.1,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						} 
					]
				},
				logisticsVolume  : {
						title: "北京市物流运量规模综合分析评估",
						htmls: '<ul class="alist dotlist"> <li>北京市物流运量规模综合评分为<b>89.9</b>分，在全国地级以上城市中综合排名第<b>3</b>名，超越全国其他<b>99.4%</b>城市。</li> <li>在构成物流运量规模的<b>5</b>个指标中，北京市相对得分最高的指标是<b>民用航空货邮运量、民用航空客运量和公路水路客运量</b>三个指标。</li> <li style="display:none">北京市物流运量规模在地级以上城市中，排名第<b>1</b>位。</li> </ul>',
						data: [{
								name: "公路水路客运量",
								score: 96,
								ranking: 7,
								remark: "超过全国98.2%的城市"
							},
							{
								name: "民用航空客运量",
								score: 98.1,
								ranking: 2,
								remark: "超过全国99.7%的城市"
							},
							{
								name: "公路货运量",
								score: 61.8,
								ranking: 41,
								remark: "超过全国98.1%的城市"
							},
							{
								name: "水运货运量",
								score: 79.5,
								ranking: 11,
								remark: "超过全国97%的城市"
							},
							{
								name: "民用航空货邮运量",
								score: 100,
								ranking: 1,
								remark: "超过全国100%的城市"
							} 
						]
					}, 
				laborAdequacy  : {
					title: "北京市劳动力充裕度综合分析评估",
					htmls: '<ul class="alist dotlist"> <li>北京市劳动力充裕度综合评分为<b>90.3</b>分，在全国地级以上城市中综合排名第<b>4</b>名，超越全国其他<b>99.1%</b>城市。</li> <li>在构成劳动力充裕度的<b>4</b>个指标中，北京市相对得分最高的指标是<b>城镇单位从业人员期末数和普通高等学校在校生数</b>二个指标。</li> <li style="display:none">北京市劳动力充裕度在地级以上城市中，排名第<b>1</b>位。</li> </ul>',
					data: [{
							name: "户籍人口数量",
							score: 86.9,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						},
						{
							name: "城镇单位从业人员期末数",
							score: 97.4,
							ranking: 2,
							remark: "超过全国99.7%的城市"
						},
						{
							name: "普通高等学校在校生数",
							score: 91.5,
							ranking: 11,
							remark: "超过全国97%的城市"
						},
						{
							name: "中等职业教育学校学生数",
							score: 83.5,
							ranking: 12,
							remark: "超过全国96.7%的城市"
						} 
					]
				},
				sctalentResources  : {
					title: "北京市科技人才资源综合分析评估",
					htmls: '<ul class="alist dotlist"> <li>北京市科技人才资源综合评分为<b>94.9</b>分，在全国地级以上城市中综合排名第<b>4</b>名，超越全国其他<b>99.1%</b>城市。</li> <li>在构成科技人才资源的<b>6</b>个指标中，北京市相对得分最高的指标是<b>科学技术支出、普通高等学校数量和科学研发强度</b>三个指标。</li> <li style="display:none">北京市科技人才资源在地级以上城市中，排名第<b>1</b>位。</li> </ul>',
					data: [{
							name: "科学技术支出",
							score: 100,
							ranking: 1,
							remark: "超过全国100%的城市"
						},
						{
							name: "科学研发强度",
							score: 97.7,
							ranking: 3,
							remark: "超过全国99.4%的城市"
						},
						{
							name: "普通高等学校数量",
							score: 100,
							ranking: 1,
							remark: "超过全国100%的城市"
						},
						{
							name: "普通高等学校在校生数",
							score: 91.5,
							ranking: 11,
							remark: "超过全国97%的城市"
						},
						{
							name: "每万人在校大学生数",
							score: 63.4,
							ranking: 43,
							remark: "超过全国87.5%的城市"
						},
						{
							name: "大学学生从业人员比",
							score: 44.3,
							ranking: 169,
							remark: "超过全国50%的城市"
						}
					]
				},
				livingEnvironment  : {
					title: "北京市生活居住环境综合分析评估",
					htmls: '<ul class="alist dotlist"> <li>北京市生活居住环境综合评分为<b>98.9</b>分，在全国地级以上城市中综合排名第<b>3</b>名，超越全国其他<b>99.4%</b>城市。</li> <li>在构成生活居住环境的<b>4</b>个指标中，北京市相对得分最高的指标是<b>生态环境质量和医疗服务水平</b>二个指标。</li> <li style="display:none">北京市生活居住环境在地级以上城市中，排名第<b>1</b>位。</li> </ul>',
					data: [
						{name:"基础教育水平",datas:[{name:"每万人普通中学数量",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"每万人普通小学数量",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"普通中学在校生数",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"普通小学在校生数",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"普通小学生师比",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"普通中学生师比",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},]},
						{name:"医疗服务水平",datas:[{name:"医院、卫生院数量",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"医院、卫生院床位数",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"医生数（医师、助理医师）",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"每万人拥有医院、卫生院数",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"每万人拥有床位数",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"每万人拥有医生数",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},]},
						{name:"城市公交服务",datas:[{name:"人均城市道路面积",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"每万人拥有公共汽车数量	",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"每万人拥有出租车数量",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"人均使用公共汽车次数",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},]},
						{name:"生态环境质量",datas:[{name:"	人均绿地面积",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"人均公园绿地面积",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},{name:"建成区绿化覆盖率",score: 44.3,ranking: 169,remark: "超过全国50%的城市"},]},
					], 
				},
			};
			this.articledata = articledata;

		},
		mounted() {
			var _this = this; 
			this.echartsradar('echart_radar1', this.articledata.investmentenvironment.data);
			this.echartsradar('echart_radar2', this.articledata.economicstrength.data);
			this.echartsradar('echart_radar3', this.articledata.developmentQuality.data);
			this.echartsradar('echart_radar5', this.articledata.marketSize.data);
			this.echartsradar('echart_radar7', this.articledata.laborAdequacy.data);
		 var lengthsd=document.getElementsByClassName('ph-heading').length; 
			for(var i=0;i<lengthsd;i++){
				var offsetstops=document.getElementsByClassName('ph-heading')[i].offsetTop;
				floortoparry.push(offsetstops);
			}
		 window.addEventListener("scroll", this.handleScroll, true);
		},
		methods: {
			handleScroll: function(e) {
				var sctop = document.documentElement.scrollTop;
				var actop = document.getElementById('investmentdata-article').offsetTop - 80;
				if (sctop > actop) {
					this.showfloor = true;
				} else {
					this.showfloor = false;
				}
				if(floortoparry.length>0){
					for(var d=0;d<floortoparry.length;d++){
						if(sctop>floortoparry[d] && sctop<floortoparry[d+1]){
							this.curstepp=d; 
						}else if(sctop>floortoparry[floortoparry.length-1]){
							this.curstepp=floortoparry.length-1; 
						} 
					} 
				}  
			},
			echartsradar: function($el, data) {
				var chart = this.$echarts.init(document.getElementById($el));
				var _this = this;
				var indicatordata=data.map(function(item){
					return {name:item.name,max:100};
				});
				var numdata=data.map(function(item){
					return item.score;
				})
				var options = {
					title: {
						text: ''
					},
					// color:
					tooltip: {},
					legend: {
						 data: ["指标得分"], top: "bottom"
					},
					radar: {
						// shape: 'circle',
						name: {
							textStyle: {
								color: '#fff',
								backgroundColor: '#999',
								borderRadius: 3,
								padding: [3, 5]
							}
						},
						indicator: indicatordata
					},
					series: [{
						name: ' ',
						type: 'radar',
						// areaStyle: {normal: {}},
						data: [{
								value: numdata,
								name: ' ',
								lineStyle: BetaConfig.itemStyle(1),
								itemStyle: BetaConfig.itemStyle(1),
								areaStyle: BetaConfig.itemStyle(1)
							} 
						]
					}]
				};
				chart.setOption(options);
			},
		},
	}
</script>

<style>
</style>
